export const consentCTA = {
  All: 'Accept all',
  Close: 'Close modal',
  RequiredOnly: 'Required cookies only',
} as const
